export default "__VITE_ASSET__C2oCrgIQ__"